import themes from '@bnnvara/themes';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { keyframes } from 'styled-components';
const frames = keyframes`
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(0.5, 1);
  }
  40% {
    transform: scale(1);
  }
`;
const LoadBar = styled.div`
  margin: 3px 0 0;
  height: 6px;
  width: 100%;
  background-color: ${({
  color
}) => color};
  animation: ${frames} 1s ease-in-out infinite;

  &:nth-child(1) {
    margin-top: 0;
    animation-delay: 0;
  }

  &:nth-child(2) {
    animation-delay: 0.09s;
  }

  &:nth-child(3) {
    animation-delay: 0.18s;
  }
`;
const Loader = styled.div`
  display: block;
  width: ${props => props.width}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: rotate(-3deg);
`;

const LoadingIcon = ({
  width,
  color
}) => /*#__PURE__*/React.createElement(Loader, {
  role: "status",
  "aria-label": "laden",
  width: width
}, /*#__PURE__*/React.createElement(LoadBar, {
  color: color
}), /*#__PURE__*/React.createElement(LoadBar, {
  color: color
}), /*#__PURE__*/React.createElement(LoadBar, {
  color: color
}));

LoadingIcon.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string
};
LoadingIcon.defaultProps = {
  width: 32,
  color: themes.bnnvara.primary.main
};
export default LoadingIcon;